<template>
  <div class="content">
    <div class="content-header">
      <ContentBox title="账号管理" class="content-box">
        <el-tabs :value="activeName" @input="handleChangeRouter" :class="isMounted ? 'table-tabs': 'table-tabs--before-mount'">
          <el-tab-pane
            v-for="item in loginAccountList"
            :key="item.name"
            :label="item.title"
            :name="item.name"
          >
            <span slot="label" @click.stop="handleChangeRouter(item.name)">{{item.title}}</span>
            <slot :name="item.name"></slot>
          </el-tab-pane>
        </el-tabs>
      </ContentBox>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeName: {
      type: String,
      defalut: ''
    }
  },
  data() {
    return {
      isMounted: false
    }
  },
  computed: {
    loginAccountList() {
      const data = [
        {
          name: 'loginAccountInfo',
          title: '登录账号信息',
          show: this.$appState.$get('permissions')['currentAccount']
        },
        {
          name: 'collaborationAccount',
          title: '协作账号管理',
          show: this.$appState.$get('permissions')['agentAccount:list']
        },
        {
          name: 'entityQualification',
          title: '主体资质管理',
          show: this.$appState.$get('permissions')['partner:data']
        },
        {
          name: 'advertiserManage',
          title: '广告主管理',
          show: this.$appState.$get('permissions')['partner:list'] && this.$service.state.user.accountType === '1'
        },
        {
          name: 'advertiserAccountManage',
          title: '广告主账号管理',
          show: this.$appState.$get('permissions')['customer:list'] && this.$service.state.user.accountType === '1'
        }
      ]
      const list = data.filter(item => item.show)
      return list
    }
  },
  methods: {
    handleChangeRouter(val) {
      this.$router.push({ name: val })
    }
  },
  mounted() {
    this.isMounted = true
  },
  created() {
  }
}
</script>

<style lang="stylus" scoped>
.content-box {
  margin-bottom: 0;

  >>>.content-box__header {
    height: 72px;
  }

  >>>.content-box__header {
    height: 72px;
  }

  >>>.title {
    width: 80px;
    height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
    padding: 24px 0 20px 32px;
  }

  >>>.content-box__main {
    margin: 0;
  }
}

.table-tabs {
  >>>.el-tabs__nav-wrap:after {
    content: none;
  }
  >>>.el-tabs__header {
    margin 0 0 0 40px
    padding-bottom 1px
  }
  >>>.el-tabs__item {
    font-size 16px
    height 61px
    line-height 70px
  }
}
</style>
